import { AxiosResponse, isAxiosError } from 'axios';
import createAxiosInstance from '../middlewares/axios.interceptors';

const postsUrl = '/posts';

export const PostsService = {
  getPosts: async (page: number) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(postsUrl + '/list' + '?page=' + page);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  createPost: async (data: any) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(postsUrl + '/create', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  updatePost: async (data: any) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(postsUrl + '/update', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  deletePost: async (id: number) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.delete(postsUrl + '/delete', {
        params: {
          id
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  }
};
